import { isValidDomain, serializeRawDomain } from './domains/domains';
export const isValidKeyword = (keyword) => {
    if (keyword.length < 3) {
        return {
            result: false,
            message: `"${keyword}" keyword is too short. Keywords must consist of at least 3 characters.`,
        };
    }
    if (keyword.split(' ').length > 6) {
        return {
            result: false,
            message: `"${keyword}" keyword consists of too many terms. Max allowed is six.`,
        };
    }
    if (keyword.includes('1800') || keyword.includes('1 800')) {
        return {
            result: false,
            message: `"${keyword}" keyword includes 1800 phone number which is not allowed.`,
        };
    }
    if (isValidDomain(serializeRawDomain(keyword))) {
        return {
            result: false,
            message: `"${keyword}" keyword is a domain name. Domains are not allowed as keywords.`,
        };
    }
    return { result: true };
};
//# sourceMappingURL=isValidKeyword.js.map